import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { VideoCategoryInput } from "../store/actionType";
import { createVideoCategory } from "../store/action";
import { CreateCategoryForm } from "modules/video/components/CreateFolderForm";
import { CategoryError, CategoryInput } from "modules/video/components/DataType";
import { ApiError } from "components";

interface CreateCategoryProps {
  groupId: string;
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & CreateCategoryProps;

const CreateCategory: React.FC<Props> = ({
  closeModal,
  groupId,
  onCreatehVideoCategory,
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState<CategoryInput>({
    name: "",
    description: "",
  category_order: 0
  });
  const [error, setError] = useState<CategoryError>({});
  const [apiError, setApiError] = useState(null);
   const categoriesState = useSelector(
    (state: any) => state.videoCategories.videoCategoriesState
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    var input: VideoCategoryInput = {
      name: formData.name,
      description: formData.description,
      category_order: formData.category_order,
      group_id: groupId.toString(),
    };
    if (formData.name.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,
        name: "Category Name is required",
      }));
    }
    if (formData.description.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,
        description: "Category Description is required",
      }));
    }
    if (formData.category_order === 0) {
      setError((prevErrors) => ({
        ...prevErrors,
        category_order: "Category category order is required",
      }));
    }
    if (formData.name.trim() !== "" && formData.description.trim() !== "") {
      setLoading(true);
      onCreatehVideoCategory(input);
      setSubmitted(true);
      setLoading(false);
    }
  };
  useEffect(() => {
      if (!categoriesState.isLoading && submitted) {
        if (categoriesState.error) {
          setApiError(categoriesState.error); // show error
        } else {
          setApiError(null);
          closeModal(false);
        }
      }
    }, [categoriesState.isLoading, categoriesState.error, submitted, closeModal]);
  return (
    <>
      <CreateCategoryForm
        loading={loading}
        formData={formData}
        errors={error}
        handleChange={handleChange}
        handleSubmit={handleSave}
        header={"Create Category"}
      />
       {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onCreatehVideoCategory: (input: VideoCategoryInput) =>
    dispatch(createVideoCategory(input)),
});

export default connect(null, mapDispatchToProps)(CreateCategory);
